import React from 'react';
import ReactTooltipWrapper from '../../../../frontend/components/components/utils/ReactTooltipWrapper';

const Tooltips = ({}) => {
  const justATestingLabel = () => (
    <label data-tip='The tooltip here!'>Here you have a child label tooltip!</label>
  );
  const justHTMLLabel = "<label data-tip='The tooltip here!'>Here you have a Text HTML label tooltip</label>";

  return(
    <div className="styles-section row" id="tooltips">
      <div className='main-page-title col-12'>
        <h3>Tooltips</h3>
      </div>

      <div className='home-page-content col-sm-12'>
        <h4>HTML text tooltip</h4>
        <ReactTooltipWrapper 
          innerHtml={justHTMLLabel}
          tooltipProps={{
            type: "light", 
            place: "top", 
            effect: "solid", 
            border: true
          }}
        />
      </div>

      <div className='home-page-content col-sm-12 mt-4'>
        <h4>Child component tooltip</h4>
        <ReactTooltipWrapper 
          tooltipProps={{
            type: "light", 
            place: "top", 
            effect: "solid", 
            border: true
          }}
        >
          {justATestingLabel()}
        </ReactTooltipWrapper>
      </div>
    </div>
  );
}

export default Tooltips;
